import React from 'react';
import { Icon } from './Icon.js';
export const IconAward2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,13.5c-1.478,0-2.853-.447-4-1.209v4.459c0,.286,.162,.547,.419,.673,.254,.126,.561,.097,.788-.079l2.793-2.148,2.793,2.148c.134,.103,.295,.156,.457,.156,.113,0,.227-.025,.331-.077,.257-.126,.419-.387,.419-.673v-4.459c-1.147,.762-2.522,1.209-4,1.209Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "9", cy: "6.25", r: "5.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconAward2Fill18.js.map